
function makeAppConfig() {
    let date = new Date();
    let year = date.getFullYear();
    
    return {
        brand: 'SENSIT TECHNOLOGIES',        
        year: year,
        layoutBoxed: false,                             
        navCollapsed: false,                            
        navBehind: false,                               
        fixedHeader: true,                              
        sidebarWidth: 'large',                         
        theme: 'light',                                
        colorOption: '25',                             
        AutoCloseMobileNav: true,                              
    };    
}
export const APPCONFIG = makeAppConfig();


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/config.ts